import { forwardRef } from 'react';
import Modal from 'react-modal';
import './styles.scss';

const DeleteEmployeeModal = forwardRef(({ closeModal, handleDeleteEmployee }, ref) => {
  const handleClose = () => {
    closeModal();
  };

  return (
    <Modal
      className="modal-alert delete-employee-modal"
      isOpen
      onRequestClose={handleClose}
      contentLabel="Delete note modal"
      ariaHideApp={false}
      contentRef={(node) => {
        ref.current = node;
      }}
    >
      <h2 className="modal-header">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="5" y="5" width="38" height="38" rx="19" fill="#FEE4E2" />
          <rect x="5" y="5" width="38" height="38" rx="19" stroke="#FFF2F1" strokeWidth="10" />
          <g clipPath="url(#clip0_13465_79709)">
            <path
              d="M23.9999 21.3359V24.0026M23.9999 26.6693H24.0066M30.6666 24.0026C30.6666 27.6845 27.6818 30.6693 23.9999 30.6693C20.318 30.6693 17.3333 27.6845 17.3333 24.0026C17.3333 20.3207 20.318 17.3359 23.9999 17.3359C27.6818 17.3359 30.6666 20.3207 30.6666 24.0026Z"
              stroke="#B42318"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_13465_79709">
              <rect width="16" height="16" fill="white" transform="translate(16 16)" />
            </clipPath>
          </defs>
        </svg>

        <button className="btn btn-icon" onClick={handleClose}>
          <i className="icon-icon-x"></i>
        </button>
      </h2>

      <div>
        <h3>Confirm employee deletion from this shift?</h3>
        <p className="modal-subtitle">This action is irrevisible and will permanently delete the employee from this shift.</p>
      </div>
      <div className="modal-footer">
        <button className="btn btn-outline" onClick={handleClose}>
          Cancel
        </button>
        <button
          className="btn btn-danger delete-line-btn"
          onClick={() => {
            handleDeleteEmployee();
          }}
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2.5 4.9974H4.16667M4.16667 4.9974H17.5M4.16667 4.9974V16.6641C4.16667 17.1061 4.34226 17.53 4.65482 17.8426C4.96738 18.1551 5.39131 18.3307 5.83333 18.3307H14.1667C14.6087 18.3307 15.0326 18.1551 15.3452 17.8426C15.6577 17.53 15.8333 17.1061 15.8333 16.6641V4.9974H4.16667ZM6.66667 4.9974V3.33073C6.66667 2.8887 6.84226 2.46478 7.15482 2.15222C7.46738 1.83966 7.89131 1.66406 8.33333 1.66406H11.6667C12.1087 1.66406 12.5326 1.83966 12.8452 2.15222C13.1577 2.46478 13.3333 2.8887 13.3333 3.33073V4.9974M8.33333 9.16406V14.1641M11.6667 9.16406V14.1641"
              stroke="white"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Confirm
        </button>
      </div>
    </Modal>
  );
});

export default DeleteEmployeeModal;
